import { FC } from 'react';

type ParagraphComponentProps = {
  className: string;
  value: string;
};

const ParagraphComponent: FC<ParagraphComponentProps> = ({
  className,
  value,
}) => {
  return (
    <div>
      <p className={`${className}`}>{value}</p>
    </div>
  );
};

export default ParagraphComponent;
